import React from "react";
import { Alert } from "@paysera/react-common";

import Department from "./component/Department";
import { Spinner, CountryDropdown, DepartmentDropdown } from "../shared/components";
import useGetVacancies from "./hooks/useGetVacancies";
import useFilterByDepartment from "./hooks/useFilterByDepartment";
import { PREFERRED_CAREER_COUNTRIES } from '../shared/config/constants';

const Vacancies = () => {
  const {
    vacancies,
    isLoading,
    error,
    handleCountryChange,
  } = useGetVacancies();

  const {
    filteredVacancies,
    departments,
    handleDepartmentChange,
  } = useFilterByDepartment(vacancies);

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Alert bsStyle="danger">{error}</Alert>
  }

  return (
    <>
      <div className="filters-container">
          <CountryDropdown
            onCountryChange={handleCountryChange}
            availableCountries={PREFERRED_CAREER_COUNTRIES}
          />
        {!!departments.length && (
            <DepartmentDropdown
              departments={departments}
              onDepartmentChange={handleDepartmentChange}
          />
        )}
      </div>
      <div className="vacancies-list">
        {filteredVacancies.map((vacancy) => (
          <Department
            key={vacancy?.department?.id}
            department={vacancy?.department?.name}
            vacancies={vacancy?.vacancies}
          />
        ))}
      </div>
    </>
  );
};

export default Vacancies;
